import { render, staticRenderFns } from "./ReservaFd.vue?vue&type=template&id=12ed0f5d&"
import script from "./ReservaFd.vue?vue&type=script&lang=js&"
export * from "./ReservaFd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports